export default __webpack_public_path__ + "static/media/cladding19.51b9b11c.gif";